module.exports = __webpack_public_path__ + "img/banner_truck.5229d013.png";